import {GET_TITLE_TREE} from 'shared/constants/ActionTypes';

const INIT_STATE = {
  detail: '',
};

export const getTitleTreeReducers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TITLE_TREE:
      console.log("reducers ACTION PAYLOAD",action.payload.detail);
      return {
        ...state,
        detail: action.payload.detail,
      };
    default:
      return state;
  }
};

export default getTitleTreeReducers;
